var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatchlist = function SvgWatchlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 52 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeWidth: 2.5,
    d: "M2.535 20.092a4.359 4.359 0 0 1 0-4.184C7.067 7.62 15.875 2 26 2c10.124 0 18.933 5.622 23.465 13.908a4.358 4.358 0 0 1 0 4.184C44.933 28.38 36.125 34 26 34 15.876 34 7.067 28.378 2.535 20.092Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M18 18a8 8 0 1 0 8-8"
  })));
};
export default SvgWatchlist;